import { mapState, mapGetters } from 'vuex';
import twemoji from 'twemoji';
import { CONVERSATION_ROLE } from '@/constants';
import moment from 'moment-timezone';

export default {
  data() {
    return {
      currentNotification: null,
      callNotifications: {},
      monthsRu: ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'],
      monthsEn: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    };
  },
  computed: {
    ...mapState('cache', ['chats']),
    ...mapGetters('context', ['currentUserId'])
  },
  methods: {
    copyClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = '2em';
      textArea.style.height = '2em';
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';
      textArea.style.background = 'transparent';
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.log(`Copying text command was ${msg}`);
      } catch (err) {
        console.log('Oops, unable to copy');
      }

      document.body.removeChild(textArea);
    },
    readableDate(date) {
      const month = date.getMonth();
      return this.$i18n.locale === 'ru'
        ? `${date.getDate()} ${this.monthsRu[month].toLowerCase()}`
        : `${date.getDate()} ${this.monthsEn[month].toLowerCase()}`;
    },
    readableFullDate(date) {
      return new Date(date).toLocaleDateString();
    },
    readableTime(date) {
      return new Date(date).toLocaleTimeString().slice(0, 5);
    },
    replaceEmojiWithAltAttribute(text) {
      return text.replace(
        /<img draggable="false" class="emoji".*?alt="(.*?)"[^>]+>/g,
        '$1'
      );
    },
    emojiParse(value) {
      return twemoji.parse(value);
    },
    getAge(day, month, year) {
      if (year === null) return '';

      const born = new Date(year, month - 1, day);
      const age = this.$dates.differenceInYears(new Date(), born);
      if (age === 0) return '';
      const ageString = age.toString();
      const lastTwo = parseInt(ageString.slice(-2), 10);
      let word = '';
      if (lastTwo > 10 && lastTwo < 15) {
        word = 'лет';
      } else {
        const lastOne = parseInt(ageString.slice(-1), 10);
        switch (lastOne) {
          case 1:
            word = 'год';
            break;
          case 2:
          case 3:
          case 4:
            word = 'года';
            break;
          default:
            word = 'лет';
            break;
        }
      }
      return `${age} ${word}`;
    },
    getMessage(text) {
      if (text === null || text === undefined || text === '') return '';
      const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
      text = text?.replaceAll('\n', '<br />') || null;
      text = text.replace(exp, "<a href='$1' target='_blank'>$1</a>");
      return twemoji.parse(text);
    },
    deepCopy(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    async markChatAsRead(chatId) {
      const chat = this.chats.find(x => x.id === chatId);
      if (chat) {
        chat.anyUnreadMessage = false;
        await this.$http(`Chat/SetChatRead?chatId=${chatId}`);
      }
    },
    stopCallNotification(chatId) {
      if (this.callNotifications[chatId]) {
        this.callNotifications[chatId].close();
      }

      const ringAudio = document.getElementById('phone-ring');
      ringAudio.pause();
      ringAudio.currentTime = 0;
    },
    notifyCall(chatId, clickCallback = () => {}, withoutCall) {
      const chat = this.chats.find(x => x.chatId === chatId);
      const { type } = chat;
      if (withoutCall === this.currentUserId) return;
      let subTitle = '';
      let imgLink = '';
      if (type === CONVERSATION_ROLE.Dialog) {
        subTitle = chat.title;
        imgLink = `${process.env.VUE_APP_API_IMAGE_URL}Avatar/getUserAvatar?id=${chat.userId}`;
      } else {
        subTitle = chat.title;
        imgLink = `${process.env.VUE_APP_API_IMAGE_URL}Avatar/getChatAvatar?id=${chatId}&m=${Date.now()}`;
      }
      this.callNotifications[chatId] = this.$notify({
        title: type === 0 ? 'Звонок от пользователя' : 'Звонок из чата',
        dangerouslyUseHTMLString: true,
        message: this.getNotificationHtml(imgLink, subTitle),
        position: 'bottom-right',
        customClass: 'notify-container',
        duration: 0,
        onClick: () => {
          clickCallback();
          this.stopCallNotification(chatId);
        },
        onClose: () => {
          this.stopCallNotification(chatId);
        }
      });
      try {
        const ringAudio = document.getElementById('phone-ring');
        ringAudio.currentTime = 0;
        ringAudio.play();
      } catch (e) {
        console.log(e);
      }
    },
    notifyFriendshipOffer(user) {
      const options = {
        title: 'Новая заявка в друзья',
        subtitle: `${user.surName} ${user.name}`,
        imgLink: `${process.env.VUE_APP_API_IMAGE_URL}Avatar/getUserAvatar?id=${user.id}`,
        onClick: () => this.nmOpenFriends(true)
      };
      this.showNotification(options);
    },
    notifyFriendshipAcceptence(user) {
      const options = {
        title: 'Заявка в друзья принята',
        subtitle: `${user.surName} ${user.name}`,
        imgLink: `${process.env.VUE_APP_API_IMAGE_URL}Avatar/getUserAvatar?id=${user.id}`,
        onClick: () => this.nmOpenFriends(false)
      };
      this.showNotification(options);
    },
    nmOpenFriends(requestsTab) {
      this.$router.push({
        name: 'Friends',
        query: requestsTab ? { openRequests: true } : null
      });

      if (this.currentNotification) {
        this.currentNotification.close();
      }
    },
    notifyChatInvitation(chat) {
      chat = this.chats.find(x => x.chatId === chat.chatId);
      const options = {
        title: 'Вас пригласили в чат',
        imgLink: `${process.env.VUE_APP_API_IMAGE_URL}Avatar/getChatAvatar?id=${chat.chatId}`,
        subtitle: chat.title,
        onClick: () => this.nmOpenChat(chat.chatId)
      };
      this.showNotification(options);
    },
    dateToLocalTimezone(date) {
      console.log(date);
      const tzDate = moment.utc(date, this.getFormatDate(date), this.$i18n.locale).local();
      return tzDate.calendar(null, {
        sameDay: () => `${this.$t('moment.today')}, HH:mm`,
        nextDay: () => `${this.$t('moment.tomorrow')}, HH:mm`,
        nextWeek: () => 'dddd',
        lastDay: () => `${this.$t('moment.yesterday')}, HH:mm`,
        lastWeek: () => `${this.$t('moment.last')} dddd`,
        sameElse: () => {
          if (tzDate.year() === moment().year()) {
            return this.$i18n.locale === 'ru' ? 'DD.MM, HH:mm' : 'MMM Do, HH:mm a';
          } return 'lll';
        }
      });
    },
    getFormatDate(date) {
      if (date.includes('/')) return 'MM/DD/YYYY HH:mm:ss';
      if (date.includes('-')) return 'YYYY-MM-DDTHH:mm:ss';
      return 'DD.MM.YYYY HH:mm:ss';
    },
    timeToLocalTimezone: date => moment.utc(date, 'YYYY-MM-DDTHH:mm:ss').local().format('HH:mm'),
    async notifyNewMessage(message) {
      if (message.systemMessage) return;

      const fullnameResponse = await this.$http(`/profile/fullname?userId=${message.senderId}`);
      const subtitle = fullnameResponse.data;
      const options = {
        title: 'Новое сообщение',
        imgLink: `${process.env.VUE_APP_API_IMAGE_URL}Avatar/getUserAvatar?id=${message.senderId}`,
        subtitle,
        text: message.text,
        onClick: async () => { await this.nmOpenChat(message.chatId); }
      };
      this.showNotification(options);
    },
    showNotification(options) {
      this.currentNotification = this.$notify({
        title: options.title,
        dangerouslyUseHTMLString: true,
        message: this.getNotificationHtml(
          options.imgLink,
          options.subtitle,
          options.text
        ),
        position: 'bottom-right',
        customClass: 'notify-container',
        duration: options.duration === undefined ? 10000 : options.duration,
        onClick: options.onClick
      });
    },
    async nmOpenChat(chatId) {
      const domain = `${window.location.protocol}//${window.location.host}`;
      window.location.replace(`${domain}/chats/Conversation?chatId=${chatId}`);
      if (this.currentNotification) {
        this.currentNotification.close();
      }
    },
    getNotificationHtml(imgLink, subtitle, text) {
      const image = imgLink
        ? `<img class='notif-avatar' src="${imgLink}" alt="Avatar">`
        : '';
      return `<div class='notif-wrap'>
                        <div class='notif-avatar-wrap'>
                            ${image}
                        </div>
                        <div class='notif-content-wrap'>
                            <div>
                                <div class='notif-subtitle'>${
  subtitle || ''
}</div>
                                <div class='notif-text'>${
  text || ''
}</div>
                            </div>
                        </div>
                    </div>`;
    }
  }
};
